import { profileStorageKey } from './profileStorageKey';

const PENDING_LOGO_PREFIX = 'ofrontend.businessClientPendingLogo';

function safeGet(key: string): string | null {
  try {
    return localStorage.getItem(key)?.trim() || null;
  } catch {
    return null;
  }
}

function safeSet(key: string, value: string): void {
  try {
    localStorage.setItem(key, value);
  } catch {
    /* ignore */
  }
}

function safeRemove(key: string): void {
  try {
    localStorage.removeItem(key);
  } catch {
    /* ignore */
  }
}

/** Logo picked at register — uploaded on first profile save after sign-in. */
export function persistPendingBusinessClientLogo(dataUrl: string, loginId?: string | null): void {
  if (!dataUrl.startsWith('data:image/')) {
    return;
  }
  safeSet(profileStorageKey(PENDING_LOGO_PREFIX, loginId), dataUrl);
}

export function getPendingBusinessClientLogo(loginId?: string | null): string | null {
  const value = safeGet(profileStorageKey(PENDING_LOGO_PREFIX, loginId));
  return value?.startsWith('data:image/') ? value : null;
}

export function clearPendingBusinessClientLogo(loginId?: string | null): void {
  safeRemove(profileStorageKey(PENDING_LOGO_PREFIX, loginId));
}
